<legend>
  {{ step8.getspan9 | translate }}
</legend>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[rule]="'required'"
[errorMessage]="{'required' : 'ctr_443'}"
[value]="indexation?.dateFinDiffusion"
[label]="step8.getdatefindiffusion"
[type]="'date'"
[name]="getUid()+'_SepAtt_dateFinDiffusion'">
</app-form-input>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg1" [id]="getStepId() + rg1"></app-form-input-error>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg2" [id]="getStepId() + rg2"></app-form-input-error>

<app-form-input
[parentForm]="parentForm"
[value]="indexation?.objetAvis"
[label]="step8.getobjetavis"
[type]="'text'"
[disabled]="disabled"
[rule]="'required|minSize_1|maxSize_200'"
[errorMessage]="{'required' : 'ctr_9410'}"
[name]="getUid()+'_SepAtt_objetAvis'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[value]="indexation?.nomOrganisme"
[label]="step8.getnomorganisme"
[type]="'text'"
[disabled]="disabled"
[rule]="'required|minSize_5|maxSize_400'"
[errorMessage]="{'minLength' : 'ctr_9400', 'maxLength' : 'ctr_9409'}"
[name]="getUid()+'_SepAtt_nomOrganisme'">
</app-form-input>


<span class="d-block">{{ step8.getspan10 | translate}}</span>

<!--
  PRB0052504 : les deux critères sont obligatoires et ne peuvent plus être décochés une fois cochés
  (cf. FormInputComponent.checkRadioButton). Le défaut à 'Non' est posé par
  TypeIndexationComponent.applyCriteresDefaults.
  Note : pattern_29 est le pendant du @Pattern(regexp = "") du back ; sur une valeur simple
  Validators.pattern('') retourne nullValidator, la règle ne valide donc rien. Elle est conservée
  par symétrie avec le contrat back, seul 'required' est effectif ici.
-->
<app-form-input
[parentForm]="parentForm"
[label]="step8.getspan11"
[type]="'radio'"
[disabled]="disabled"

[rule]="'required|pattern_29'"
[value]="indexation?.criteresSociaux"
[name]="getUid() + '_SepAtt_criteresSociaux'"
[radios]="[
  {
              value: 'Oui',
    label: step8.getoui
  },
  {
              value: 'Non',
    label: step8.getnon
  },
]">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[label]="step8.getspan13"
[type]="'radio'"
[disabled]="disabled"
[rule]="'required|pattern_29'"
[value]="indexation?.criteresEnvironnementaux"
[name]="getUid() + '_SepAtt_criteresEnvironnementaux'"
[radios]="[
  {
              value: 'Oui',
    label: step8.getoui
  },
  {
              value: 'Non',
    label: step8.getnon
  },
]">
</app-form-input>

<app-type-mots-clef  [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled" [motsClef]="indexation?.motsClef"></app-type-mots-clef>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg3" [id]="getStepId() + rg3"></app-form-input-error>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg4" [id]="getStepId() + rg4"></app-form-input-error>

    <app-type-dept [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled"
	[deptPublication]="indexation?.deptPublication"></app-type-dept>
